import React from 'react';
import { useTranslation } from 'react-i18next';

interface FeatureCardProps {
  icon: string | React.ReactNode;
  title: string;
  description: string;
}

function FeatureCard({ icon, title, description }: FeatureCardProps) {
  return (
    <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-shadow">
      <div className="mb-4 flex items-center justify-center h-16">
        {typeof icon === 'string' ? (
          <div className="text-4xl">{icon}</div>
        ) : (
          icon
        )}
      </div>
      <h3 className="text-xl font-semibold mb-2">{title}</h3>
      <p className="text-gray-600">{description}</p>
    </div>
  );
}

export function FeaturesSection() {
  const { t } = useTranslation();

  const features = [
    {
      icon: (
        <img 
          src="/fsc.png" 
          alt="FSC" 
          className="h-16 w-auto object-contain"
        />
      ),
      title: t('features.fsc.title'),
      description: t('features.fsc.description'),
    },
    {
      icon: (
        <img 
          src="/MADE IN FINLAND.svg" 
          alt="Made in Finland" 
          className="h-16 w-auto object-contain"
        />
      ),
      title: t('features.printedInTampere.title'),
      description: t('features.printedInTampere.description'),
    },
    {
      icon: '✓',
      title: t('features.satisfaction.title'),
      description: t('features.satisfaction.description'),
    },
  ];

  return (
    <section className="bg-white/80 backdrop-blur-sm py-16 lg:py-24">
      <div className="container mx-auto px-4 max-w-7xl">
        <h2 className="text-3xl lg:text-4xl font-bold text-center mb-12">
          {t('features.title')}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <FeatureCard
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

